import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Brittle extends Modifier {
  static readonly baseTitle = 'Brittle';
  static readonly baseText = 'Increase damage taken by stacks, then remove.';
  static readonly baseIcon = 'brittle';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Early;

  // Instance properties that can change
  title = Brittle.baseTitle;
  text = Brittle.baseText;
  icon = Brittle.baseIcon;
  tags: Array<ModifierTags> = [...Brittle.baseTags];
  priority = Brittle.basePriority;

  damageIn(damage: Damage) {
    damage.value += this.stacks;
    this.removeStacks(this.stacks);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Brittle, Brittle);
